export default "__VITE_ASSET__BUOQ38Iv__"